import React from "react";

export default function RefundFromSupplier() {
  return <div>RefundFromSupplier</div>;
}
